import { CompoundButtonTemplate } from "@fluentui/web-components";
import { styles as CompoundButtonStyles } from "./compound-button.styles.js";
import { DesignSystem } from "../design-system.js";
import { CompoundButton } from "./compound-button.js";
/**
 * The Fabric Compound Button component.
 *
 * @public
 */
export const definition = CompoundButton.compose({
    name: `${DesignSystem.prefix}-compound-button`,
    template: CompoundButtonTemplate,
    styles: CompoundButtonStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=compound-button.definition.js.map